/**
 * Accepting an invitation triggers a hard page reload (the legacy Redux store
 * has to re-bootstrap with the new org — see `useAcceptInvitation`). The invite
 * JWT is gone from the URL after that reload, so the org-switcher coach mark
 * can't key off it. Instead we stash the just-joined org id in `localStorage`
 * right before the reload and read it back once, on the next load.
 *
 * The value is the organization id the user just joined, so the coach mark only
 * fires when the reloaded session actually lands in that org (the server sets
 * it as `currentOrganization` on accept).
 */
const JUST_JOINED_ORG_KEY = 'buffer:justJoinedOrg'

export function markJustJoinedOrg(organizationId: string): void {
  try {
    window.localStorage.setItem(JUST_JOINED_ORG_KEY, organizationId)
  } catch {
    // localStorage can throw in private-mode / storage-disabled browsers.
    // The coach mark is a non-critical nudge, so swallow and move on.
  }
}

export function readJustJoinedOrg(): string | null {
  try {
    return window.localStorage.getItem(JUST_JOINED_ORG_KEY)
  } catch {
    return null
  }
}

export function clearJustJoinedOrg(): void {
  try {
    window.localStorage.removeItem(JUST_JOINED_ORG_KEY)
  } catch {
    // no-op — see markJustJoinedOrg
  }
}
